import styled from 'styled-components';
import { Button, Card, Tooltip } from '@veneer/core';
import { primitives } from '@veneer/primitives';
const { color, layout, typography } = primitives;

interface CardProps {
  selected?: boolean;
  isdisabled?: boolean;
}
export const StyledCard = styled(Card)<CardProps>`
  && {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: ${typography.size4} !important;
    gap: 10px;
    background: ${({ isdisabled }) => (isdisabled ? color.gray3 : color.white)};
    pointer-events: ${({ isdisabled }) => (isdisabled ? 'none' : 'auto')};
    border: ${({ selected }) =>
      selected
        ? '2px solid #007bff !important'
        : '1px solid #E0E0E0 !important'};
    border-radius: ${layout.cornerRadius4}px;
    height: 100%;
    /* Apply opacity to all direct children except TitleWrapper (which contains the Tag) */
    > *:not(:first-child) {
      opacity: ${({ isdisabled }) => (isdisabled ? 0.6 : 1)};
    }

    /* Apply opacity to TitleWrapper's first child (PrinterCardLabel) but not the Tag */
    > *:first-child > *:first-child {
      opacity: ${({ isdisabled }) => (isdisabled ? 0.6 : 1)};
    }
  }
`;

export const StyledImage = styled.img`
  width: 216px;
  height: 168px;
  padding: 0px;
`;
export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Title = styled.div`
  margin-bottom: 14px;
  font-weight: ${typography.weight4};
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight4};
  color: ${color.gray7};
  font-family: ${typography.family0};
`;

export const Description = styled.p`
  font-weight: ${typography.weight3};
  font-size: ${typography.size2};
  line-height: ${typography.size4};
  color: ${color.gray7};
  margin-bottom: 8px;
  min-height: 40px;
`;

export const Link = styled.a<{ isDisabled?: boolean }>`
  font-weight: ${typography.weight3};
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight2};
  display: flex;
  align-items: center;
  text-align: center;
  text-decoration-line: underline;
  color: ${({ isDisabled }) =>
    isDisabled ? color.gray7 : color.electricBlue7};
`;
export const PrinterDivider = styled.hr`
  border: 0;
  border-top: 1px solid #e0e0e0;
  margin: 15px 0;
`;

export const Price = styled.p`
  font-weight: ${typography.weight4};
  font-size: ${typography.size4};
  line-height: ${typography.lineHeight5};
  color: ${color.black};
`;

export const Commitment = styled.p`
  font-weight: ${typography.weight3};
  font-size: 14px;
  line-height: ${typography.lineHeight2};
  display: flex;
  align-items: center;
  color: ${color.gray9};
  margin-bottom: 12px;
`;

export const PagesPerMonth = styled.div`
  display: inline-flex;
  font-weight: ${typography.weight3};
  font-size: 14px;
  line-height: ${typography.lineHeight2};
  color: ${color.gray12};
  margin-bottom: 12px;
  div {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-right: 4px;
  }
`;

export const PlanNote = styled.div`
  background: ${color.electricBlue0};
  padding: 8px ${typography.size2};
  min-height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin-bottom: ${layout.size3}px;
  div {
    font-weight: ${typography.weight3};
    font-size: ${typography.size0};
    line-height: ${typography.lineHeight1};
  }
  b {
    font-weight: ${typography.weight6};
  }
`;

export const SelectButton = styled(Button)`
  width: 100%;
  height: 48px;
`;
export const ImageContainer = styled.div`
  align-self: flex-start;
  display: contents;
  align-items: center;
  flex: 1;
  min-width: 0;
  p {
    margin-left: 8px;
  }
`;
export const CurrentPlanInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const PrinterCardLabel = styled.p`
  font-family: ${typography.family0};
  font-style: normal;
  font-weight: ${typography.weight4};
  font-size: ${typography.size5};
  line-height: ${typography.lineHeight4};
  color: ${color.black};
`;

export const ToolTipText = styled.div`
  font-size: ${typography.size0};
  line-height: ${typography.lineHeight1};
  font-weight: ${typography.weight3};
  color: ${color.white};
  max-width: 200px;
  white-space: normal;
  word-wrap: break-word;
  padding: ${layout.size1}px;
`;

export const StyledTooltip = styled(Tooltip)`
  vertical-align: sub !important;
  margin-left: 2px !important;
`;
